"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchDrawingWithLayersSchema = void 0;
const DrawingWithLayers_1 = require("./DrawingWithLayers");
const SchDrawing_1 = require("./SchDrawing");
exports.SchDrawingWithLayersSchema = (0, DrawingWithLayers_1.DrawingWithLayersSchemaT)(SchDrawing_1.SchDrawingSchema);
//# sourceMappingURL=SchDrawingWithLayers.js.map